import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 pb-28 pt-12 text-navy-300 sm:pb-24" data-id="element-152" data-mp="207t1q85t1jl1">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-153" data-mp="209x5mq3peilb">
        <p className="text-center text-sm font-black uppercase tracking-[0.28em] text-white" data-id="element-154" data-mp="2f3ikzyjlvim2">
          Dr. Karito
        </p>

        <div className="mt-8 rounded-2xl border border-white/10 bg-white/[0.03] p-4 sm:p-6" data-id="element-155" data-mp="2a3nqll0mgaw9">
          <h2 className="flex items-center gap-2 text-[12px] font-black uppercase tracking-wide text-navy-100 sm:text-sm" data-id="element-156" data-mp="1me1tr47q27rf">
            <AlertTriangleIcon className="h-4 w-4 shrink-0 text-[#f5a524]" aria-hidden="true" data-id="element-157" data-mp="1w5z7oiq47dtu" />
            Important medical disclaimer
          </h2>
          <div className="mt-3 space-y-3 text-[12.5px] leading-relaxed sm:text-[13.5px]" data-id="element-158" data-mp="1reh73vs07f9e">
            <p data-id="element-159" data-mp="13omw7jr8w0rs">
              The Clinical Decision System for Diabetes is an educational resource intended for
              healthcare professionals.
            </p>
            <p data-id="element-160" data-mp="1eic4vbx4mqst">
              It does not replace individual clinical judgment, a complete patient assessment,
              official prescribing information, local or national clinical guidelines, emergency
              protocols, specialist consultation, or applicable laws and regulations.
            </p>
            <p data-id="element-161" data-mp="1sa0ffarq977o">
              Recommendations and treatment availability may vary by country, healthcare system, and
              patient-specific circumstances.
            </p>
            <p data-id="element-162" data-mp="zktbtxdf1rfk">
              Healthcare professionals remain responsible for all diagnostic and treatment
              decisions.
            </p>
          </div>
        </div>

        <p className="mt-8 text-center text-[12px] text-navy-400" data-id="element-163" data-mp="14lzascxo6axj">
          © 2026 Dr. Karito • All Rights Reserved
        </p>
      </div>
    </footer>;
}